import PropTypes from "prop-types";

import AuthTooltip from "../../AuthTooltip";

const AuthInputTooltip = ({ title, body, placement = "top" }) => (
  <span className="d-inline-flex align-items-center justify-content-center">
    <AuthTooltip
      title={title}
      body={body}
      placement={placement}
      className="d-inline-flex"
    />
  </span>
);

AuthInputTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  placement: PropTypes.string,
};

export default AuthInputTooltip;
